import { Deserializable } from './deserializable.model';
import { Image } from './image.model';

export class Pessoa implements Deserializable {
  id = '';
  nome = '';
  ativo = false;
  imagens = new Array<Image>();
  sobre = '';
  expertises = new Array();
  funcao = '';

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }
}
